<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        รายการ Device 3rd Party
      </span>
      <v-scroll-x-transition>
        <div class="d-flex align-center" v-if="!formShow">
          <v-text-field
            v-model="search"
            class="mr-2"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            placeholder="รหัส - ชื่อ Device"
            @input="handleSearch"
            style="width: 220px"
          ></v-text-field>
          <v-autocomplete
            v-model="filterArea"
            class="mr-4"
            :items="
              this.areas.length
                ? [
                    {
                      title_th: 'ไม่ระบุพื้นที่',
                      area_uuid: 'not_specified',
                    },
                    ...areas,
                  ]
                : []
            "
            :loading="loadingAreas"
            item-text="title_th"
            item-value="area_uuid"
            label="พื้นที่"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            style="width: 240px; background-color: white"
            @change="handleFilterArea"
          ></v-autocomplete>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::hardware_3rd_party:create')
            "
            color="primary"
            @click="handleAddDevice"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่ม Device
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loadingHardwares"
      :headers="headers"
      :items="hardwares"
      :options.sync="options"
      :server-items-length="totalHardwares"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
      multi-sort
    >
      <template v-slot:item.area_code="{ item }">
        <div v-if="!item.area" class="grey--text text-darken-1">-</div>
        <div v-else>
          <div>{{ item.area.area_code }}</div>
          <div class="caption grey--text text--darken-1">
            {{ item.area.title_th }}
          </div>
        </div>
      </template>
      <template v-slot:item.title_hardware_model="{ item }">
        <div>{{ item.hardware_model ? item.hardware_model.title : '' }}</div>
      </template>
    </v-data-table>
    <HardwareDevice3rdPartyForm
      :formShow="formShow"
      :formAction="formAction"
      :hardware="hardware"
      :hardwareInit="hardwareInit"
      @isHardwareDataChange="handleHardwareFormDataChange"
      @formActionCompleted="handleHardwareFormActionCompleted"
      @onReset="handleHardwareFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
    <v-overlay
      :value="formShow && formAction === 'add'"
      z-index="0"
    ></v-overlay>
  </v-container>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import HardwareDevice3rdPartyForm from '@/views/hardware-device-3rd-party/HardwareDevice3rdPartyForm.vue'

export default {
  components: {
    ConfirmDialog,
    HardwareDevice3rdPartyForm,
  },
  data() {
    return {
      dialogForbidden: false,
      loadingAreas: false,
      loadingHardwares: false,
      search: '',
      filterArea: null,
      headers: [
        { text: 'พื้นที่', width: 220, value: 'area_code' },
        { text: 'รหัส Device', width: 180, value: 'hardware_code' },
        { text: 'ชื่อ Device', value: 'title_th' },
        { text: 'ชื่อรุ่น Device', value: 'title_hardware_model' },
        { text: 'โน๊ตเพิ่มเติม', value: 'note' },
      ],
      sortBy: ['area_code', 'hardware_code'],
      sortDesc: [false, false],
      options: {},
      formShow: false,
      formAction: '',
      hardware: {
        hardware_model: {},
        area: {},
      },
      hardwareInit: {
        hardware_model: {},
        area: {},
      },
      isHardwareDataChange: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
    }
  },
  watch: {
    options: {
      handler() {
        this.getHardware3rdParties()
      },
      deep: true,
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    hardwares() {
      return this.$store.state.hardware3rdParty.hardwares
    },
    totalHardwares() {
      return this.$store.state.hardware3rdParty.totalHardwares
    },
    areas() {
      return this.$store.state.area.areas
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'รายการ Device 3rd',
        disabled: true,
      },
    ])

    try {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: { dpc: 'hardware-3rd-party-to-list-area-no-filter' },
      }

      this.loadingAreas = true

      this.fetchAreas(payload)
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loadingAreas = false
    }
  },
  methods: {
    ...mapActions({
      fetchAreas: 'area/fetchAreas',
      fetchHardware3rdParties: 'hardware3rdParty/fetchHardware3rdParties',
      fetchHardware3rdParty: 'hardware3rdParty/fetchHardware3rdParty',
      fetchHardwareModels: 'hardware/fetchHardwareModels',
    }),
    async handleAddDevice() {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('btn:::hardware_3rd_party:create')
      ) {
        this.dialogForbidden = true
        return
      }

      await this.getHardwareModels()

      this.formShow = true
      this.formAction = 'add'
      this.hardware = {
        hardware_model: {},
        area: {},
        is_used_for_work_time_calculation: false,
      }
      this.hardwareInit = {
        hardware_model: {},
        area: {},
        is_used_for_work_time_calculation: false,
      }
    },
    async getHardwareModels() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        await this.fetchHardwareModels({
          params: { is_manageable: false },
        })
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleSearch() {
      this.getHardware3rdPartiesBySearch()
    },
    handleFilterArea() {
      this.options.page = 1
      this.getHardware3rdParties()
    },
    getHardware3rdPartiesBySearch: _.debounce(function () {
      this.options.page = 1
      this.getHardware3rdParties()
    }, 500),
    async getHardware3rdParties() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const sortParams = sortBy
        .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
        .join(',')

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            search: this.search || undefined,
            area_uuid: this.filterArea || undefined,
            sort: sortParams || undefined,
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
          },
        }

        this.loadingHardwares = true

        await this.fetchHardware3rdParties(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingHardwares = false
      }
    },
    classRowSelected(row) {
      if (this.hardware.hardware_uuid === row.hardware_uuid)
        return 'row-selected'
    },
    async setDataRowSelected(row) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('row:::hardware_3rd_party:get')
      ) {
        this.dialogForbidden = true
        return
      }

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_3rd_party_uuid: row.hardware_uuid,
        }

        await this.fetchHardware3rdParty(payload)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
        } else {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }

        return
      }

      if (this.hardware.hardware_uuid === row.hardware_uuid) {
        this.formShow = false
        this.formAction = ''
        this.hardware = {
          hardware_model: {},
          area: {},
        }
        this.hardwareInit = {
          hardware_model: {},
          area: {},
        }
      } else {
        await this.getHardwareModels()

        this.formShow = true
        this.formAction = 'edit'
        this.hardware = {
          ...row,
          hardware_model: { ...row.hardware_model },
          area: row.area ? { ...row.area } : {},
        }
        this.hardwareInit = {
          ...row,
          hardware_model: { ...row.hardware_model },
          area: row.area ? { ...row.area } : {},
        }
      }
    },
    handleRowSelected(row) {
      if (this.isHardwareDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleHardwareFormDataChange(value) {
      this.isHardwareDataChange = value
    },
    handleHardwareFormReset() {
      this.hardware = {
        hardware_model: {},
        area: {},
      }
      this.hardwareInit = {
        hardware_model: {},
        area: {},
      }
      this.formShow = false
      this.formAction = ''
    },
    handleHardwareFormActionCompleted(formAction) {
      this.hardware = {
        hardware_model: {},
        area: {},
      }
      this.hardwareInit = {
        hardware_model: {},
        area: {},
      }
      this.formShow = false
      this.formAction = ''

      if (formAction === 'add') {
        this.options.page = 1
        this.getHardware3rdParties()
      } else if (formAction === 'edit') {
        this.getHardware3rdParties()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false
      this.formAction = ''

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isHardwareDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
